// Query keys for React Query - Admin Panel
export const queryKeys = {
  // Admin-specific keys
  ADMIN_USERS: 'ADMIN_USERS',
  ADMIN_USER: 'ADMIN_USER',
  ADMIN_BUSINESSES: 'ADMIN_BUSINESSES',
  ADMIN_BUSINESS: 'ADMIN_BUSINESS',
  ADMIN_CATEGORIES: 'ADMIN_CATEGORIES',
  ADMIN_FILTERS: 'ADMIN_FILTERS',
  ADMIN_ANALYTICS: 'ADMIN_ANALYTICS',
  ADMIN_USER_ABILITIES: 'ADMIN_USER_ABILITIES',
  ADMIN_USER_PLANS: 'ADMIN_USER_PLANS',
  ADMIN_DASHBOARD: 'ADMIN_DASHBOARD',
  ADMIN_IMPORT_STATUS: 'ADMIN_IMPORT_STATUS',
  ADMIN_IMPORT_PREVIEW: 'ADMIN_IMPORT_PREVIEW',
  ADMIN_REFRESH_PREVIEW: 'ADMIN_REFRESH_PREVIEW',
};
